<script>
export default {
	name: 'Menu-Routes',
	functional: true,
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			menu_drop: false,
			menu_navigator: null,
		};
	},
	methods: {
		listGenerator(items) {
			return (
				<ul>
					{items.map(route => {
						let children;

						if (route.children) children = this.listGenerator(route.children);

						return (
							<li>
								{route.name ? (
									route.name === 'merchant-picker' ? (
										<a onClick={this.showMerchantPicker}>
											<span>{this.$t(route.title)}</span>
										</a>
									) : (
										<router-link to={route}>
											<span>{this.$t(route.title)}</span>
										</router-link>
									)
								) : (
									<a href="#" onClick={e => e.preventDefault()}>
										<span>{this.$t(route.title)}</span>
									</a>
								)}
								{children}
							</li>
						);
					})}
				</ul>
			);
		},
		showMerchantPicker() {
			this.$emit('showMerchantPicker');
		},
	},
	render() {
		return <div class="menuArea">{this.listGenerator(this.items)}</div>;
	},
};
</script>

<style>
.rtr_home .header.affected .menuArea > ul > li > a {
	color: #333;
}
.rtr_home .menuArea > ul > li > a {
	color: hsla(0, 0%, 100%, 0.5);
}
.menuArea {
	text-align: center;
}
.menuArea li {
	display: inline-block;
}
.menuArea ul {
	display: none;
}
.menuArea > ul {
	display: inline-block;
}
.menuArea li:hover ul {
	display: block;
}
.menuArea > ul > li > a {
	display: block;
	padding: 25px 30px;
	font-size: 18px;
	color: #333;
	cursor: pointer;
}
.menuArea > ul > li > a span {
	position: relative;
	padding: 22px 2px;
}
.menuArea > ul > li > a span:before {
	content: '';
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 0;
	height: 4px;
	background-color: #ca0000;
	transition: 0.5s;
	transform: translateX(-100%);
}
.rtr_home .menuArea > ul > li:hover > a {
	color: #fff;
}
.menuArea > ul > li:hover > a span:before {
	width: 100%;
	left: 100%;
}
.menuArea > ul > li:hover > ul {
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: #fff;
}
.is_logged_in .menuArea > ul > li:hover > ul:before {
	height: 100px;
}
.menuArea > ul > li:hover > ul:before,
.menuArea > ul > li > ul {
	top: 69px;
}
.menuArea > ul > li > ul {
	position: absolute;
	left: 0;
}
.menuArea > ul > li > ul > li {
	width: 180px;
	margin-right: 30px;
	padding: 40px 0 25px 0;
	transform: translateX(33%);
}
.menuArea > ul > li > ul > li > a {
	text-align: left;
}
.menuArea > ul > li > ul > li > a span {
	display: block;
	padding-bottom: 20px;
	color: #000;
	font-size: 15px;
	font-weight: 600;
}
.menuArea > ul > li > ul > li > ul {
	margin-right: 30px;
	text-align: left;
}
.menuArea > ul > li > ul > li > ul > li {
	display: block;
	margin-bottom: 15px;
}
.menuArea > ul > li > ul > li > ul > li > a {
	display: block;
	color: #868686;
	font-size: 14px;
}
</style>
